export default __webpack_public_path__ + "static/media/img-login.83d47dfb.svg";